import { Component, ElementRef, OnInit, ViewChild, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ObtenerDatosService } from 'src/app/servicios/datos/obtener-datos/obtener-datos.service';
import { GlobalesService } from 'src/app/servicios/globales.service';
import { RutasService } from 'src/app/servicios/rutas/rutas.service';
import { Location } from '@angular/common';

import { ThemeService } from '../../../theme/theme.service';

// declare var $;
// import * as $ from 'jquery';

@Component({
  selector: 'app-votos-anticipados-gob',
  templateUrl: './votos-anticipados-gob.component.html',
  styleUrls: ['./votos-anticipados-gob.component.scss']
})

export class VotosAnticipadosGobComponent implements OnInit {
  status: any;
  acta_electronico: string = '';
  acta_postal: string = '';
  casilla_table: any = [];
  resumen: any = [];
  estadistica_anticipados: any = [];
  base: string;
  fichas: any = [];
  selectedContienda: any = '';
  selectedOptionIndx: number = -1;
  selectedOption = 'Todas';
  isOpenCombo = false;
  firstLoad = true; 
  actasRoot = ""
  showEscaner = false
  showMovil = false
  showConfCatd = false
  showCATD = false
  objCasilla: any = {}
  casillasInfo: any = [];

  constructor(
    public _globalService: GlobalesService,
    private readonly activatedRouter: ActivatedRoute,
    public readonly rutas: RutasService,
    public location: Location,
    public _obtenerDatosService: ObtenerDatosService,
    public themeService: ThemeService,
  ) { }

  ngOnInit(): void {
      this.obtenerParametros();
      this.getScreenSize()
      this._obtenerDatosService.mainSubject.subscribe(data =>{
        if(data == null) return;
        this.loadData();
        this._globalService.returnURL = '/diputaciones/votos-distrito/mapa'
        this.actasRoot = data?.actas_root ? data?.actas_root : ""
        this._globalService.menuActual = "RP";
    });
  }

  loadData() {
      this.selectedContienda = this._globalService.getContienda();
      var ruta = '';
      // if(this.selectedContienda == 'gubernatura'){
      //   ruta = 'votos-anticipados';
      // }else{
        ruta = 'seccion.'+ this._globalService.param_distrito +'.anticipados';
      // }

      this._obtenerDatosService.loadJSON(this.selectedContienda, ruta).then(data => {
          this.resumen = data['resumen'];
          this.casilla_table = data['casilla_table'];
          this.casillasInfo = data['casillas'];
          this.estadistica_anticipados = data['estadistica'];
          //this._obtenerDatosService.desglose = data['casilla_table'];
          this.fichas = data['fichas'];
          this._globalService.bottomSheetTpl = 'simple';
          this._globalService.bottomSheeTitle = 'Mesas';
          var optCombo = [{index: -1, text: "Todas", param: ''}],
              optIndex = 0;
          data['casilla_table']['rows'].forEach(item => {
            optCombo.push({index: optIndex, text: item.text, param: item.param});
            optIndex++;
          });
          console.log({optCombo});

          this._globalService.bottomSheetData = optCombo;
          this.selectedOptionIndx = -1
          this.status = data['status'];
          this.acta_electronico = ""//this.casilla_table.rows[0].status.file;
          this.acta_postal = ""//this.casilla_table.rows[1].status.file;
          this._globalService.callbackCasillaData.subscribe((parametros) => {
            this.itemSelected(parametros)
          });
         console.log("casillasInfo: ",this.casillasInfo);
         this.objCasilla = data;
          
//      this._obtenerDatosService.participacion_table = data['participacion_table'].rows;
//
//      // this.grafica_table = data['grafica'].columns;
//      // this.total_votos = '1000';
          
      });
    // }
  }

  obtenerParametros() {
    this.activatedRouter.params.subscribe((parametros) => {
      const params = { parametros };
      this._globalService.detalles = params.parametros;
    });
    this._globalService.setearParametros();
  }

  @ViewChild('widgetsContent', { read: ElementRef }) public widgetsContent: ElementRef<any>;

  public scrollRight(): void {
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft + 150), behavior: 'smooth' });
  }

  public scrollLeft(): void {
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft - 150), behavior: 'smooth' });
  }

  itemSelected(index:any) {
    if(this.firstLoad){
      this.firstLoad = false
      return;
    }
    this.openBottomSheet()
    this.selectedOptionIndx = index.index;
    var posCombo = this.selectedOptionIndx + 1;
    this.selectedOption = index.text;
  }

  openBottomSheet(){
    this.isOpenCombo = !this.isOpenCombo;
    this._globalService.toggleBottomSheet(this.isOpenCombo);
  }

  atras() {
    this.location.back();
    this._globalService.menuActual = 'Votos';
    window.scrollTo(0, 0);
}

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
      const scrWidth = window.innerWidth;
      console.log('WINDOW WIDTH:  ', scrWidth);
      //this._globalService.menuActual = scrWidth <= 1200 ? 'vP' : 'RP';
      this._globalService.menuActual = "RP";
  }

  goToAnchor(el: HTMLElement) {
    const offset = -20;
    
    window.scroll({
      top: el.offsetTop + offset,
      behavior: 'smooth'
    });
  }

}